<template>
    <div>
        <div class="modal-header">
            <h5 class="modal-title">{{ productId ? 'Edit Produk' : 'Tambah Produk' }}</h5>
            <button type="button" class="close" @click="$emit('close')">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form @submit.prevent="submitForm">
                <!-- Tipe Produk (paling atas, kondisional render lain) -->
                <div class="form-group">
                    <label>Tipe Produk *</label>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="border rounded p-3 d-block" :class="{ 'border-primary bg-light': form.type === 'physical' }" style="cursor:pointer">
                                <input type="radio" v-model="form.type" value="physical"> &nbsp;
                                <i class="fas fa-box"></i> <b>Fisik</b>
                                <small class="d-block text-muted">Barang nyata, perlu dikirim</small>
                            </label>
                        </div>
                        <div class="col-md-6">
                            <label class="border rounded p-3 d-block" :class="{ 'border-primary bg-light': form.type === 'digital' }" style="cursor:pointer">
                                <input type="radio" v-model="form.type" value="digital"> &nbsp;
                                <i class="fas fa-cloud-download-alt"></i> <b>Digital</b>
                                <small class="d-block text-muted">Ebook, kursus, akses link, dll</small>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Nama Produk *</label>
                            <input type="text" v-model="form.name" class="form-control" required @input="autoSlug" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Slug *</label>
                            <input type="text" v-model="form.slug" class="form-control" required />
                            <small class="text-muted">URL produk: /toko/{slug-toko}/produk/{slug-ini}</small>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Kategori</label>
                    <select v-model="form.category_id" class="form-control">
                        <option :value="null">-- Tanpa kategori --</option>
                        <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                    <small class="text-muted">Kelola kategori di menu Categories</small>
                </div>

                <div class="form-group">
                    <label>Deskripsi</label>
                    <textarea v-model="form.description" class="form-control" rows="4" placeholder="Deskripsi detail produk..."></textarea>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Harga (Rupiah) *</label>
                            <input type="number" v-model.number="form.price" class="form-control" required min="0" />
                        </div>
                    </div>
                    <div class="col-md-6" v-if="form.type === 'physical'">
                        <div class="form-group">
                            <label>Stok</label>
                            <input type="number" v-model.number="form.stock" class="form-control" min="0" />
                            <small class="text-muted">Kosongkan untuk unlimited</small>
                        </div>
                    </div>
                </div>

                <!-- PHYSICAL ONLY: Berat untuk ongkir -->
                <div v-if="form.type === 'physical'">
                    <div class="form-group">
                        <label>Berat (gram) *</label>
                        <input type="number" v-model.number="form.weight_grams" class="form-control" min="0" placeholder="500" />
                        <small class="text-muted">Untuk hitung ongkir RajaOngkir. Berat 1 produk (bukan total order).</small>
                    </div>

                    <div class="form-group">
                        <label>Varian Produk</label>
                        <small class="text-muted d-block mb-2">Misal: Warna (Merah, Biru), Ukuran (S, M, L). Setiap varian set nama + opsi (pisah koma).</small>
                        <div v-for="(v, i) in form.variants" :key="i" class="border rounded p-2 mb-2">
                            <div class="row">
                                <div class="col-md-4">
                                    <input v-model="v.name" class="form-control mb-1" placeholder="Nama varian (Warna)">
                                </div>
                                <div class="col-md-7">
                                    <input :value="v.options.join(', ')" @input="setVariantOptions(i, $event.target.value)" class="form-control mb-1" placeholder="Opsi pisah koma (Merah, Biru)">
                                </div>
                                <div class="col-md-1">
                                    <button type="button" class="btn btn-sm btn-danger" @click="removeVariant(i)"><i class="fas fa-trash"></i></button>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-light" @click="addVariant"><i class="fas fa-plus"></i> Tambah Varian</button>
                    </div>
                </div>

                <!-- DIGITAL ONLY: Akses produk -->
                <div v-if="form.type === 'digital'">
                    <div class="form-group">
                        <label>Akses Produk Digital * <span class="badge badge-info">Auto-deliver setelah bayar</span></label>
                        <textarea v-model="form.digital_access_text" class="form-control" rows="5"
                            placeholder="Link download: https://drive.google.com/abc&#10;Password: starxxx&#10;Atau kode redeem: ABC-XYZ-123"
                            :required="form.type === 'digital'"></textarea>
                        <small class="text-muted">Konten ini otomatis dikirim ke WA & email customer setelah pembayaran sukses.</small>
                    </div>
                    <div class="form-group">
                        <label>Email Subject (untuk delivery)</label>
                        <input v-model="form.digital_email_subject" class="form-control" placeholder="Akses Ebook Marketing 101">
                        <small class="text-muted">Default: "Akses Produk: [nama produk]" kalau dikosongkan.</small>
                    </div>
                    <div class="form-group">
                        <button type="button" class="btn btn-outline-success btn-sm" @click="testKirimAkses" :disabled="testingAccess || !form.digital_access_text">
                            <span v-if="testingAccess" class="spinner-border spinner-border-sm mr-1"></span>
                            📤 Test Kirim Akses (WA)
                        </button>
                        <small class="d-block text-muted mt-1">Kirim preview akses ke nomor WA Anda untuk uji coba.</small>
                    </div>
                </div>

                <!-- IMAGES (multi) -->
                <div class="form-group">
                    <label>Gambar Produk Utama</label>
                    <div v-if="form.image_url" class="mb-2">
                        <img :src="form.image_url" style="max-width:200px; max-height:200px; border-radius:8px; border:1px solid #ddd;">
                        <button type="button" @click="removeMainImage" class="btn btn-sm btn-danger ml-2"><i class="fas fa-times"></i> Hapus</button>
                    </div>
                    <div v-if="uploadingImage" class="mb-2">
                        <div class="spinner-border spinner-border-sm"></div> Mengupload...
                    </div>
                    <input type="file" @change="onMainImageChange" class="form-control" accept="image/*" ref="mainImageInput" :disabled="uploadingImage">
                    <small class="text-muted">Atau paste URL:</small>
                    <input type="text" v-model="form.image_url" class="form-control mt-1" placeholder="https://...">
                </div>

                <div class="form-group">
                    <label>Gambar Tambahan (multi, optional)</label>
                    <div v-if="extraImages.length > 0" class="mb-2 d-flex flex-wrap" style="gap:8px">
                        <div v-for="(img, i) in extraImages" :key="i" style="position:relative">
                            <img :src="img" style="width:100px; height:100px; object-fit:cover; border-radius:6px; border:1px solid #ddd;">
                            <button type="button" @click="removeExtraImage(i)" class="btn btn-sm btn-danger" style="position:absolute; top:-8px; right:-8px; padding:2px 6px"><i class="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div v-if="uploadingExtra" class="mb-2"><div class="spinner-border spinner-border-sm"></div> Mengupload...</div>
                    <input type="file" @change="onExtraImageChange" class="form-control" accept="image/*" ref="extraImageInput" :disabled="uploadingExtra">
                    <small class="text-muted">Upload satu per satu. Max 4 gambar tambahan.</small>
                </div>

                <div class="form-group">
                    <label>Status</label>
                    <select v-model="form.status" class="form-control">
                        <option value="active">Active (tampil di katalog)</option>
                        <option value="inactive">Inactive (sembunyikan)</option>
                    </select>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')">Batal</button>
                    <button type="submit" class="btn btn-primary" :disabled="loading">
                        {{ loading ? 'Menyimpan...' : 'Simpan' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductForm',
    props: {
        shopId: { type: Number, required: true },
        productId: { type: Number, default: null },
    },
    data() {
        return {
            form: {
                name: '', slug: '', description: '', price: 0, type: 'physical',
                stock: null, image_url: '', digital_file_url: '',
                weight_grams: 0, category_id: null,
                images: '', variants: [],
                digital_access_text: '', digital_email_subject: '',
                status: 'active',
            },
            categories: [],
            extraImages: [], // array URL
            loading: false,
            uploadingImage: false,
            uploadingExtra: false,
            testingAccess: false,
        };
    },
    mounted() {
        this.loadCategories();
        if (this.productId) {
            this.loadProduct();
        }
    },
    methods: {
        autoSlug() {
            if (!this.productId) {
                this.form.slug = (this.form.name || '')
                    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            }
        },
        async loadCategories() {
            try {
                const r = await this.$store.dispatch('shop_category/shop_category_list', this.shopId);
                this.categories = r.data.data.categories || [];
            } catch (e) { /* noop */ }
        },
        async loadProduct() {
            try {
                const r = await this.$store.dispatch('shop_product/shop_product_detail', this.productId);
                const p = r.data.data.product;

                let parsedVariants = [];
                if (p.variants) {
                    try {
                        const v = typeof p.variants === 'string' ? JSON.parse(p.variants) : p.variants;
                        parsedVariants = Array.isArray(v) ? v : [];
                    } catch (e) { /* noop */ }
                }
                let parsedImages = [];
                if (p.images) {
                    try {
                        const im = typeof p.images === 'string' ? JSON.parse(p.images) : p.images;
                        parsedImages = Array.isArray(im) ? im : [];
                    } catch (e) { /* noop */ }
                }

                this.form = {
                    name: p.name, slug: p.slug,
                    description: p.description || '',
                    price: p.price, type: p.type,
                    stock: p.stock, image_url: p.image_url || '',
                    digital_file_url: p.digital_file_url || '',
                    weight_grams: p.weight_grams || 0,
                    category_id: p.category_id || null,
                    images: '', variants: parsedVariants,
                    digital_access_text: p.digital_access_text || '',
                    digital_email_subject: p.digital_email_subject || '',
                    status: p.status,
                };
                this.extraImages = parsedImages;
            } catch (error) {
                this.$toast.error('Gagal memuat data produk');
            }
        },
        addVariant() {
            this.form.variants.push({ name: '', options: [] });
        },
        removeVariant(i) {
            this.form.variants.splice(i, 1);
        },
        setVariantOptions(i, val) {
            this.form.variants[i].options = val.split(',').map(s => s.trim()).filter(Boolean);
        },
        onMainImageChange(e) {
            const f = e.target.files[0]; if (!f) return;
            this.uploadImageFile(f, 'main');
        },
        onExtraImageChange(e) {
            const f = e.target.files[0]; if (!f) return;
            if (this.extraImages.length >= 4) {
                this.$toast.error('Max 4 gambar tambahan'); return;
            }
            this.uploadImageFile(f, 'extra');
        },
        async uploadImageFile(file, target) {
            if (target === 'main') this.uploadingImage = true;
            else this.uploadingExtra = true;
            try {
                const fd = new FormData();
                fd.append('file', file);
                const r = await this.$store.dispatch('cdn_upload', fd);
                const url = r?.data?.data?.url;
                if (url) {
                    if (target === 'main') this.form.image_url = url;
                    else this.extraImages.push(url);
                    this.$toast.success('Upload OK');
                }
            } catch (e) {
                this.$toast.error('Gagal upload');
            } finally {
                this.uploadingImage = false;
                this.uploadingExtra = false;
                if (this.$refs.mainImageInput) this.$refs.mainImageInput.value = '';
                if (this.$refs.extraImageInput) this.$refs.extraImageInput.value = '';
            }
        },
        removeMainImage() {
            this.form.image_url = '';
            if (this.$refs.mainImageInput) this.$refs.mainImageInput.value = '';
        },
        removeExtraImage(i) {
            this.extraImages.splice(i, 1);
        },
        async testKirimAkses() {
            if (!this.productId) {
                this.$toast.error('Simpan produk dulu sebelum test kirim akses');
                return;
            }
            const phone = prompt('Nomor WA tujuan test (08xxx):');
            if (!phone) return;
            this.testingAccess = true;
            try {
                const axios = require('axios');
                await axios.post('shop/product/' + this.productId + '/test-access', { phone });
                this.$toast.success('Test akses dikirim ke ' + phone);
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Gagal kirim test');
            }
            this.testingAccess = false;
        },
        async submitForm() {
            if (this.form.type === 'digital' && !this.form.digital_access_text) {
                this.$toast.error('Akses Produk Digital wajib diisi');
                return;
            }
            this.loading = true;
            try {
                const payload = {
                    ...this.form,
                    images: JSON.stringify(this.extraImages),
                    variants: JSON.stringify(this.form.variants.filter(v => v.name && v.options.length > 0)),
                };
                if (this.productId) {
                    await this.$store.dispatch('shop_product/shop_product_update', { id: this.productId, data: payload });
                    this.$toast.success('Produk berhasil diupdate');
                } else {
                    await this.$store.dispatch('shop_product/shop_product_create', { shopId: this.shopId, data: payload });
                    this.$toast.success('Produk berhasil dibuat');
                }
                this.$emit('saved');
            } catch (error) {
                this.$toast.error(error.response?.data?.message || 'Gagal menyimpan produk');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
